import {H2, H3, P, PNoMargin} from '@/typography';
import {useTranslations} from 'next-intl';
import {SectionPadding} from '@/section';
import Container from '@/container';
import {Row, Col, Grid} from '@/grid';
import {withMarginBottomXl, withMarginBottomXlToSm} from '@/hocs/withSpacing';
import {withBgNeutral100, withNeutral700, withNeutral800} from '@/hocs/withColors';
import {withBoldWeight, withHeadingEyebrow, withHomeSubP} from '@/hocs/withFontType';
import {GridLayout, GridItem} from '@/ui/grid/grid-layout';
import BoxGrid from '@/ui/box-grid';
import HighlightBox from '@/ui/highlight-box';
import PictureWrapper from '@/ui/images-wrapper';

const imgPath = '/static/images/home/employee-management/';

const hireOnboardingResponsiveImages = {
  desktopImageUrl: 'hire-onboarding-desktop',
  mobileImageUrl: 'hire-onboarding-mobile'
};

const hrDataResponsiveImages = {
  desktopImageUrl: 'hr-data-desktop',
  mobileImageUrl: 'hr-data-mobile'
};

const Neutral100Section = withBgNeutral100(SectionPadding);
const EyebrowNeutral700 = withNeutral700(withHeadingEyebrow(P));
const SubPNeutral800 = withNeutral800(withHomeSubP(PNoMargin));
const TitleBlock = withMarginBottomXl('div');
const DivMargined = withMarginBottomXlToSm('div');
const BoldSpan = withBoldWeight('span');

const EmployeeManagementSection = () => {
  const t = useTranslations('homepage.employeeManagement');
  return (
    <Neutral100Section>
      <Container>
        <Grid fluid>
          <Row center="xs">
            <Col xs={12} md={10}>
              <EyebrowNeutral700>{t('eyebrow')}</EyebrowNeutral700>
              <H2>{t('title')}</H2>
              <TitleBlock>
                <SubPNeutral800>{t('subtitle')}</SubPNeutral800>
              </TitleBlock>
            </Col>
          </Row>

          <Row>
            <Col xs={12}>
              <DivMargined>
                <GridLayout Col={3} lgCol={2} autoRows>
                  <GridItem Col={2} lgCol={1}>
                    <PictureWrapper
                      imgPath={imgPath}
                      responsiveImages={hireOnboardingResponsiveImages}
                      imageTypeFallback="jpg"
                      altImage={t('imageAlt')}
                      rounded
                    />
                  </GridItem>
                  <GridItem Col={1} lgCol={1}>
                    <BoxGrid>
                      <H3>{t('box1.title')}</H3>
                      <PNoMargin>{t('box1.description')}</PNoMargin>
                    </BoxGrid>
                  </GridItem>
                  <GridItem>
                    <BoxGrid>
                      <H3>{t('box2.title')}</H3>
                      <PNoMargin>{t('box2.description')}</PNoMargin>
                    </BoxGrid>
                  </GridItem>
                  <GridItem>
                    <BoxGrid>
                      <H3>{t('box3.title')}</H3>
                      <PNoMargin>{t('box3.description')}</PNoMargin>
                    </BoxGrid>
                  </GridItem>
                  <GridItem>
                    <PictureWrapper
                      imgPath={imgPath}
                      imageUrl="performance-management"
                      imageTypeFallback="jpg"
                      altImage={t('box4.imageAlt')}
                      rounded
                    />
                  </GridItem>
                </GridLayout>
              </DivMargined>

              {/* 3rd row */}
              <DivMargined>
                <GridLayout Col={2} autoRows>
                  <GridItem Col={1} Row={2}>
                    <PictureWrapper
                      imgPath={imgPath}
                      responsiveImages={hrDataResponsiveImages}
                      imageTypeFallback="jpg"
                      altImage={t('box5.imageAlt')}
                      rounded
                    />
                  </GridItem>
                  <GridItem Col={1} Row={1}>
                    <BoxGrid>
                      <H3>{t('box5.title')}</H3>
                      <PNoMargin>{t('box5.description')}</PNoMargin>
                    </BoxGrid>
                  </GridItem>
                  <GridItem Col={1} Row={1} lgCol={2}>
                    <BoxGrid>
                      <H3>{t('box6.title')}</H3>
                      <PNoMargin>{t('box6.description')}</PNoMargin>
                    </BoxGrid>
                  </GridItem>
                </GridLayout>
              </DivMargined>

              <HighlightBox backgroundColor="var(--indigo100)">
                <PNoMargin>
                  {t.rich('infoBox.description', {
                    bold: chunks => <BoldSpan>{chunks}</BoldSpan>
                  })}
                </PNoMargin>
              </HighlightBox>
            </Col>
          </Row>
        </Grid>
      </Container>
    </Neutral100Section>
  );
};

export default EmployeeManagementSection;
